module.exports = __webpack_public_path__ + "img/Pittore-JM-006.18f12240.jpg";